import { getEnvConfig } from "@coxauto-ui/core/get-env";

declare const __webpack_init_sharing__: (scope: "default") => Promise<void>;
declare const __webpack_share_scopes__: { default: unknown };

let sharingInitialized = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const containerCache = new Map<string, any>();
const moduleCache = new Map<string, unknown>();

const COMMUNICATIONS_REMOTES: Record<string, () => string> = {
  "media-library-remote": () => getEnvConfig("communications").MEDIA_LIBRARY_URL
};

/**
 * Load a module federation remote owned by Communications.
 *
 * Unlike the shared `loadRemoteModule` from `@coxauto-ui/core/module-federation`,
 * this loader is self-contained — it resolves URLs from the Communications env
 * config, not the CXM manifest.  This means Communications can add sub-remotes
 * without modifying shared core infrastructure or requiring a host redeploy.
 */
export async function loadCommunicationsRemote(
  remoteName: string,
  moduleName: string
) {
  const cacheKey = `${remoteName}:${moduleName}`;
  if (moduleCache.has(cacheKey)) {
    return moduleCache.get(cacheKey);
  }

  const urlFactory = COMMUNICATIONS_REMOTES[remoteName];
  if (!urlFactory) {
    throw new Error(
      `[loadCommunicationsRemote] Unknown remote "${remoteName}". ` +
        `Register it in COMMUNICATIONS_REMOTES.`
    );
  }

  if (!sharingInitialized) {
    sharingInitialized = true;
    await __webpack_init_sharing__("default");
  }

  if (!containerCache.has(remoteName)) {
    const remoteUrl = urlFactory();
    const containerUrl = `${remoteUrl}${
      remoteUrl.endsWith("/") ? "" : "/"
    }remoteEntry.js`;
    const container = await import(/* webpackIgnore: true */ containerUrl);
    await container.init(__webpack_share_scopes__.default);
    containerCache.set(remoteName, container);
  }

  const container = containerCache.get(remoteName);
  const factory = await container.get(moduleName);
  const Module = factory();

  moduleCache.set(cacheKey, Module);
  return Module;
}
